var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_4389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26.5005H0.5V1.50049H26.5V26.5005Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2137 1.21973H0.298828V8.2059H26.2137V1.21973Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0643 1.36523H0.447266V8.06032H26.0643V1.36523Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5745 9.80688H6.4043V13.8822H10.5745V9.80688Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80888 19.1218H1.63867V23.1971H5.80888V19.1218Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80888 14.4644H1.63867V18.5396H5.80888V14.4644Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3401 9.80688H11.1699V13.8822H15.3401V9.80688Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5745 19.1218H6.4043V23.1971H10.5745V19.1218Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5745 14.4644H6.4043V18.5396H10.5745V14.4644Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1058 9.80688H15.9355V13.8822H20.1058V9.80688Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3401 19.1218H11.1699V23.1971H15.3401V19.1218Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3401 14.4644H11.1699V18.5396H15.3401V14.4644Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8714 9.80688H20.7012V13.8822H24.8714V9.80688Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1058 19.1218H15.9355V23.1971H20.1058V19.1218Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1058 14.4644H15.9355V18.5396H20.1058V14.4644Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8714 14.4644H20.7012V18.5396H24.8714V14.4644Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4267 27.7089C23.6685 27.7066 22.9346 27.4475 22.35 26.9756C21.7655 26.5037 21.3665 25.8483 21.221 25.1212C21.0756 24.394 21.1927 23.64 21.5524 22.9878C21.9121 22.3355 22.4922 21.8254 23.1937 21.5443C23.8952 21.2632 24.6748 21.2286 25.3995 21.4463C26.1243 21.664 26.7493 22.1206 27.1681 22.7382C27.5869 23.3559 27.7736 24.0963 27.6963 24.8334C27.619 25.5705 27.2825 26.2586 26.7442 26.7803C26.4398 27.0771 26.0783 27.312 25.6806 27.4713C25.2828 27.6307 24.8566 27.7115 24.4267 27.7089Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.426 21.5961C23.8369 21.5961 23.261 21.7668 22.7711 22.0867C22.2813 22.4065 21.8995 22.8611 21.6741 23.393C21.4486 23.9249 21.3896 24.5102 21.5045 25.0749C21.6195 25.6395 21.9032 26.1582 22.3198 26.5653C22.7363 26.9724 23.2671 27.2497 23.8449 27.362C24.4227 27.4743 25.0216 27.4166 25.5659 27.1963C26.1102 26.976 26.5754 26.6029 26.9028 26.1242C27.2301 25.6455 27.4048 25.0827 27.4048 24.507C27.4048 23.735 27.0909 22.9946 26.5323 22.4487C25.9737 21.9028 25.216 21.5961 24.426 21.5961ZM24.426 21.0139C25.133 21.0139 25.8241 21.2188 26.4119 21.6026C26.9997 21.9864 27.4579 22.532 27.7284 23.1703C27.999 23.8085 28.0697 24.5109 27.9318 25.1885C27.7939 25.8661 27.4535 26.4885 26.9536 26.977C26.4537 27.4655 25.8168 27.7982 25.1234 27.933C24.43 28.0677 23.7113 27.9986 23.0581 27.7342C22.405 27.4698 21.8467 27.0221 21.454 26.4477C21.0612 25.8732 20.8516 25.1979 20.8516 24.507C20.8516 23.5806 21.2282 22.6921 21.8985 22.037C22.5688 21.3819 23.478 21.0139 24.426 21.0139Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4258 23.3425V24.8416H26.3143",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85115 4.56717C7.42693 4.56717 7.8937 4.11103 7.8937 3.54836C7.8937 2.98568 7.42693 2.52954 6.85115 2.52954C6.27536 2.52954 5.80859 2.98568 5.80859 3.54836C5.80859 4.11103 6.27536 4.56717 6.85115 4.56717Z",
    stroke: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4683 4.56717C19.0441 4.56717 19.5109 4.11103 19.5109 3.54836C19.5109 2.98568 19.0441 2.52954 18.4683 2.52954C17.8925 2.52954 17.4258 2.98568 17.4258 3.54836C17.4258 4.11103 17.8925 4.56717 18.4683 4.56717Z",
    stroke: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8506 3.54844C6.55273 3.7522 5.18549 3.03029 5.36124 1.68254C5.39842 1.31498 5.56907 0.972572 5.84227 0.717335C6.11547 0.462098 6.47318 0.310904 6.8506 0.291132C6.8506 0.291132 7.80379 0.212538 8.11656 0.887868",
    stroke: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4678 3.54844C18.1699 3.7522 16.8027 3.03029 16.9784 1.68254C17.0156 1.31498 17.1863 0.972572 17.4595 0.717335C17.7327 0.462098 18.0904 0.310904 18.4678 0.291132C18.4678 0.291132 19.421 0.212538 19.7337 0.887868",
    stroke: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_4389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9636cb5b934ac7337620da0dafe12f54.svg";
export { ForwardRef as ReactComponent };